/**
 * @generated SignedSource<<49bd89b54d00b82924afd8922f4217b0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type ProductConfigurationStatus = "COMPLETE" | "NONE" | "PARTIAL";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
import { FragmentRefs } from "relay-runtime";
export type productList_models$data = {
  readonly models: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly additionalCodes: ReadonlyArray<{
          readonly code: string;
          readonly merchantProductName: string;
          readonly salesChannel: {
            readonly detail: {
              readonly id: string;
              readonly properties: {
                readonly name: string | null;
              } | null;
            } | null;
            readonly ecommerceSettings: {
              readonly definitiveUrl: string | null;
              readonly ecommerceName: ECommerce;
              readonly hasProductsApi: boolean;
              readonly productsApi: string | null;
              readonly remoteUrl: string | null;
            } | null;
            readonly id: string;
          };
          readonly salesChannelID: string;
        }>;
        readonly canAddAdditionalCode: boolean;
        readonly categories: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        } | null> | null;
        readonly code: string;
        readonly colors: ReadonlyArray<{
          readonly code: string | null;
          readonly colorCode: string | null;
          readonly colorID: number;
          readonly name: string;
        }>;
        readonly configurationStatus: ProductConfigurationStatus;
        readonly id: string;
        readonly modelColorMappings: ReadonlyArray<{
          readonly colorID: number;
          readonly merchantCode: string;
          readonly salesChannelID: string;
        }>;
        readonly modelID: number;
        readonly name: string;
        readonly printingMethods: ReadonlyArray<{
          readonly name: string;
          readonly printTypeID: number;
        }>;
        readonly productProviderSyncState: number;
        readonly provider: ProductProvider;
        readonly providerCode: string | null;
        readonly salesChannel: {
          readonly detail: {
            readonly id: string;
            readonly properties: {
              readonly name: string | null;
            } | null;
          } | null;
          readonly ecommerceSettings: {
            readonly definitiveUrl: string | null;
            readonly ecommerceName: ECommerce;
            readonly hasProductsApi: boolean;
            readonly productsApi: string | null;
            readonly remoteUrl: string | null;
          } | null;
          readonly id: string;
        };
        readonly smallImageUrl: string;
        readonly sourceProductTemplateID: number | null;
        readonly statusID: number;
        readonly zakekeEnvironment: ZakekeEnvironment;
      };
    }> | null;
  } | null;
  readonly " $fragmentType": "productList_models";
};
export type productList_models$key = {
  readonly " $data"?: productList_models$data;
  readonly " $fragmentSpreads": FragmentRefs<"productList_models">;
};

import modelListProductsPaginationQuery_graphql from './modelListProductsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "models"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "SalesChannel",
  "kind": "LinkedField",
  "name": "salesChannel",
  "plural": false,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "SalesChannelDetail",
      "kind": "LinkedField",
      "name": "detail",
      "plural": false,
      "selections": [
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SalesChannelDetailProperties",
          "kind": "LinkedField",
          "name": "properties",
          "plural": false,
          "selections": [
            (v2/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EcommerceSettings",
      "kind": "LinkedField",
      "name": "ecommerceSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ecommerceName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "remoteUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productsApi",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasProductsApi",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "definitiveUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "categoryID"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "productProvidersIDs"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "productStatusID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "salesChannelsIDs"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "search"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "uncategorized"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [],
      "operation": modelListProductsPaginationQuery_graphql
    }
  },
  "name": "productList_models",
  "selections": [
    {
      "alias": "models",
      "args": [
        {
          "kind": "Variable",
          "name": "categoryID",
          "variableName": "categoryID"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "productProvidersIDs",
          "variableName": "productProvidersIDs"
        },
        {
          "kind": "Variable",
          "name": "productStatusID",
          "variableName": "productStatusID"
        },
        {
          "kind": "Variable",
          "name": "salesChannelsIDs",
          "variableName": "salesChannelsIDs"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        },
        {
          "kind": "Variable",
          "name": "uncategorized",
          "variableName": "uncategorized"
        }
      ],
      "concreteType": "ModelsConnection",
      "kind": "LinkedField",
      "name": "__productsModels_models_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ModelsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Model",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                (v2/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "modelID",
                  "storageKey": null
                },
                (v3/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "providerCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "provider",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "productProviderSyncState",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "statusID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "configurationStatus",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "smallImageUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "zakekeEnvironment",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "canAddAdditionalCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sourceProductTemplateID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductCategory",
                  "kind": "LinkedField",
                  "name": "categories",
                  "plural": true,
                  "selections": [
                    (v1/*:: as any*/),
                    (v2/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProductCode",
                  "kind": "LinkedField",
                  "name": "additionalCodes",
                  "plural": true,
                  "selections": [
                    (v3/*:: as any*/),
                    (v4/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "merchantProductName",
                      "storageKey": null
                    },
                    (v5/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ModelColorMapping",
                  "kind": "LinkedField",
                  "name": "modelColorMappings",
                  "plural": true,
                  "selections": [
                    (v6/*:: as any*/),
                    (v4/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "merchantCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v5/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PrintType",
                  "kind": "LinkedField",
                  "name": "printingMethods",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "printTypeID",
                      "storageKey": null
                    },
                    (v2/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Color",
                  "kind": "LinkedField",
                  "name": "colors",
                  "plural": true,
                  "selections": [
                    (v6/*:: as any*/),
                    (v2/*:: as any*/),
                    (v3/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "colorCode",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "c9217870b9cd6ef5ba30f13fe16c4ba5";

export default node;
